import { topics } from "@/mocks/nanaData";

export default function TopicSection() {
  return (
    <section id="topics" className="bg-background-100/70 px-4 py-14 md:px-6 md:py-16" aria-label="热议话题">
      <div className="mx-auto max-w-7xl">
        <div className="text-center">
          <span className="text-xs font-semibold uppercase tracking-widest text-primary-500">热议话题</span>
          <h2 className="mt-2 font-[ZCOOL_KuaiLe] text-3xl text-foreground-950">本周讨论精选</h2>
          <p className="mx-auto mt-2 max-w-2xl text-sm text-foreground-500">
            从名场面到理性讨论，从考古回放到二创狂欢，各路话题一键围观。
          </p>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {topics.map((topic) => (
            <article
              key={topic.id}
              className="group flex flex-col overflow-hidden rounded-2xl border border-background-200 bg-background-50 transition-all hover:-translate-y-1 hover:border-primary-200"
            >
              <div className="relative h-40 overflow-hidden">
                <img
                  src={topic.image}
                  alt={topic.title}
                  title={topic.title}
                  className="h-full w-full object-cover transition-transform duration-300 group-hover:scale-105"
                />
                <span className="absolute left-3 top-3 inline-flex items-center gap-1 rounded-full bg-foreground-950/60 px-2.5 py-1 text-xs text-background-50 backdrop-blur">
                  <i className={topic.sourceIcon}></i>
                  {topic.platform}
                </span>
              </div>
              <div className="flex flex-1 flex-col p-4">
                <h3 className="text-base font-semibold leading-snug text-foreground-900 group-hover:text-primary-600">
                  {topic.title}
                </h3>
                <p className="mt-2 line-clamp-2 text-sm leading-relaxed text-foreground-500">{topic.summary}</p>
                <div className="mt-3 flex flex-wrap gap-1.5">
                  {topic.tags.map((tag) => (
                    <span key={tag} className="topic-tag">
                      # {tag}
                    </span>
                  ))}
                </div>
                <div className="mt-auto flex items-center justify-between border-t border-background-200 pt-3 text-xs text-foreground-400">
                  <span className="flex items-center gap-3">
                    <span className="flex items-center gap-1">
                      <i className="ri-fire-line text-primary-500"></i>
                      {topic.heat}
                    </span>
                    <span className="flex items-center gap-1">
                      <i className="ri-chat-3-line"></i>
                      {topic.comments.toLocaleString()}
                    </span>
                  </span>
                  <span className="whitespace-nowrap">{topic.time}</span>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}